import { _ as r } from "../internals/export.js";
import { d as t } from "../internals/descriptors.js";
import { o as e } from "../internals/object-prototype-accessors-forced.js";
import { a as o } from "../internals/a-callable.js";
import { t as s } from "../internals/to-object.js";
import "../internals/object-define-property.js";
import { __exports as a } from "../../../_virtual/object-define-property.js";
t && r({
  target: "Object",
  proto: !0,
  forced: e
}, {
  __defineSetter__: function __defineSetter__(r, t) {
    a.f(s(this), r, {
      set: o(t),
      enumerable: !0,
      configurable: !0
    });
  }
});